import { weekendScheduleService } from "../../services/api";
import { Day } from "../../types/schedule/day";

const scheduleCache: Record<number, Day[]> = {};

export async function loadDays(weekendId: number): Promise<void> {
  try {
    const response = await weekendScheduleService.getAll(weekendId);
    const list: Day[] = response.data;
    scheduleCache[weekendId] = list.sort((a, b) => a.orderID - b.orderID);
  } catch (error) {
    console.error(`Failed to load schedule for weekend ${weekendId}:`, error);
    scheduleCache[weekendId] = [];
  }
}

export function getDays(weekendId: number): Day[] {
  return structuredClone(scheduleCache[weekendId] ?? []).sort(
    (a, b) => a.orderID - b.orderID
  );
}